export interface CandidateBlockFlags {
  blocked_by?: unknown;
  hasBlocked?: unknown;
  has_blocked?: unknown;
  is_blocked?: unknown;
  isBlocked?: unknown;
  isBloacked?: unknown;
}

export interface CandidateBlockState {
  blockedByMe: boolean;
  blockedByUser: boolean;
  isBlocked: boolean;
}

export const normalizeBlockFlag = (value: unknown): boolean => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value > 0;
  if (typeof value === "string") {
    const normalizedValue = value.trim().toLowerCase();
    if (!normalizedValue || normalizedValue === "0" || normalizedValue === "false" || normalizedValue === "null") {
      return false;
    }
    if (/^\d+$/.test(normalizedValue)) {
      return Number(normalizedValue) > 0;
    }
    return normalizedValue === "true" || normalizedValue === "yes";
  }
  return false;
};

export const getCandidateBlockState = (flags?: CandidateBlockFlags | null): CandidateBlockState => {
  const blockedByMe = normalizeBlockFlag(flags?.blocked_by ?? flags?.hasBlocked ?? flags?.has_blocked);
  const blockedByUser = normalizeBlockFlag(flags?.is_blocked ?? flags?.isBlocked ?? flags?.isBloacked);

  return {
    blockedByMe,
    blockedByUser,
    isBlocked: blockedByMe || blockedByUser,
  };
};